module.exports = __webpack_public_path__ + "static/media/11-rectangle-onhold.4ee0742e.svg";